import { render, staticRenderFns } from "./Block4.vue?vue&type=template&id=4b5b5d54&scoped=true&"
import script from "./Block4.vue?vue&type=script&lang=js&"
export * from "./Block4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b5d54",
  null
  
)

export default component.exports